import React from 'react';
// import { IoIosNotificationsOutline } from "react-icons/io";
import profile from '../../assets/profile.png';

const Header = ({ username, role, userState, assignedLab, toggleSidebar }) => {
    // const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    // const toggleDrawer = () => {
    //     setIsDrawerOpen(!isDrawerOpen);
    // };

    return (
        <nav style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '25px', width: '100%' }}>
            <div className="profile">
                <div className="notification-icon"></div>
                <p>Mr./Ms. {username}<br />
                    <span style={{ fontSize: '11px', color: '#335bb2' }}>
                        {role === 1 ? "Admin" : role === 2 ? `State Officer, ${userState}` : role === 3 ? `District Officer, ${userState}` : role === 4 ? `Teacher, ${userState}` : "User"}
                        {assignedLab && <><br />Lab: {assignedLab}</>}
                    </span>
                </p>
                <img src={profile} alt="profile" />
            </div>
            <i className='bx bx-menu' onClick={toggleSidebar} style={{ fontSize: '32px', cursor: 'pointer', color: '#333' }}></i>
        </nav>
    );
};

export default Header;